import React, {Component} from "react";
import adobeDTM from "./utils/adobeDTM";
import getUserDetails from "./utils/getUserDetails";
import API_CONSTANTS from "./constants/constants";
import axios from "axios";
import {PrimaryButton, SecondaryButton} from "@sfly/uig-button";
import Modal from "./modal/modal";
import getCIDFromUri from "./utils/getCIDFromUri";
import DisplayPricing from "./shared/displyPrice/DisplayPricing";
import serverCalls from "./utils/serverCommunication";
import Loader from './../components/shared/Loader/Loader';
import CallToActionBlock from './../components/shared/CallToActionBlock/CallToActionBlock';

// Procuct description component is responsible for showing product related data, and also provide action buttons.
class ProductDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            callCopyProjects: "false",
            show: false,
            listTotalPrice: "",
            saleTotalPrice: "",
            promoMessage: ""
        };
        this.adobeEvents = new adobeDTM();
        // this.adobeEvents.init();
    }

    isUserLoggedIn = () => {
        return getUserDetails.getData(
            `${window.location.href}&openModal=true`,
            "share_product_save",
            getCIDFromUri.getData("cid")
        );
    };

    showModal = dontCall => {
        if (!dontCall) {
            this.logOmnitureEvent("save", window.location, "false", "false");
        }
        this.isUserLoggedIn().then(user => {
            console.log("inside showmodal user", user);
            if (user && user.data && user.data.uid) {
                this.setState({
                    show: !this.state.show
                });
                console.log(this.state.show);
            }
        });
    };

    onCloseModal = () => {
        this.setState({
            show: false
        });
    };

    isMobile() {
        return window.innerWidth <= 1024 || window.innerHeight <= 600;
    }

    urlParam = function (name) {
        var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
            window.location.href
        );
        if (results == null) {
            return null;
        } else {
            return decodeURI(results[1]) || 0;
        }
    };

    parseQueryString(query) {
        var vars = query.split("&");
        var query_string = {};
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            var key = decodeURIComponent(pair[0]);
            var value = decodeURIComponent(pair[1]);
            // If first entry with this name
            if (typeof query_string[key] === "undefined") {
                query_string[key] = decodeURIComponent(value);
                // If second entry with this name
            } else if (typeof query_string[key] === "string") {
                var arr = [query_string[key], decodeURIComponent(value)];
                query_string[key] = arr;
                // If third or later entry with this name
            } else {
                query_string[key].push(decodeURIComponent(value));
            }
        }
        return query_string;
    }

    componentDidMount() {
        let params, saveProject, addToCart, openModal, shareid;
        if (window.URLSearchParams) {
            params = new URLSearchParams(window.location.href);
            saveProject = params.get("save");
            addToCart = params.get("addToCart");
            openModal = params.get("openModal");
            shareid = params.get("shareid")
        } else {
            params = this.parseQueryString(window.location.href);
            saveProject = params.save;
            addToCart = params.addToCart;
            openModal = params.openModal;
            shareid = params.shareid;
        }
        console.log("params", params);
        if (saveProject === "true") {
            console.log("inside if query parameter : " + saveProject);
            this.saveProject();
        } else if (addToCart == "true") {
            this.props.addToCart();
        } else if (openModal == "true") {
            this.showModal(true);
        }
        this.getSalePriceAndPromoMessage();

    }

    getUserDetails() {
      return window.$sflyAuth.getIdToken()
          .then(idToken => {
              return window.$sflyAuth.getCurrentUser();
          })
    }

    logOmnitureEvent(location, url, redirect, logAdditionalRules) {
        this.adobeEvents.clickDTMEvent(location, url, logAdditionalRules);
        if (redirect === "true")
            setTimeout(function () {
                window.location.href = url;
            }, 100);
    }

    getSalePriceAndPromoMessage = () => {
          this.getUserDetails().then((data) => {
            serverCalls.getSalePrice("/share/v1/salePrice/", data.accessToken).then(data => {
                if (data != "error") {
                    this.setState({
                        listTotalPrice: data.listTotalPrice ? data.listTotalPrice : "",
                        saleTotalPrice: data.saleTotalPrice ? data.saleTotalPrice : "",
                        promoMessage: data.promoMessage ? data.promoMessage : ""
                    });
                }
            });
          })
    }


    onModalHide() {
        this.props.closePopup(false);
    }

    saveProject = name => {
        let locationPath = window.location.href + "&save=true";
        const projectTitle = name ? name : this.props.productName;
        getUserDetails.getData(locationPath).then(userDetails => {
            const {data} = userDetails;
            if (data != undefined && data.uid != undefined) {
                var headers = {
                    "Content-Type": "application/json",
                    "SFLY-Apikey": API_CONSTANTS.PROJECT_SERVICES_API_CONFIG, // TODO replaced from config
                    "SFLY-CALLER-ID": API_CONSTANTS.SHARE_API_CALLER_ID,
                    authorization: `Bearer ${data.accessToken}`
                };
                let baseUrl =
                    API_CONSTANTS.PROJECT_SERVICES_URL + data.uid + "/projects";

                axios
                    .post(
                        baseUrl,
                        {
                            projectGUID: this.props.projectGuid,
                            projectTitle: projectTitle,
                            copyProjectGroup: "USER",
                            copiedProjectStatus: "ACTIVE"
                        },
                        {headers: headers}
                    )
                    .then(function (response) {
                        if (response.status === 201) {
                            window.location = "/mySavedProjects/";
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        });
    };

    render() {
        const {loading, shareId, addToCart, likesCommentDataReducer} = this.props;
        const pricingPorps = {
            listTotalPrice: this.state.listTotalPrice === null ? 0 : Number(this.state.listTotalPrice.substring(4)),
            saleTotalPrice: this.state.saleTotalPrice === null ? 0 : Number(this.state.saleTotalPrice.substring(4)),
            promoMessage: this.state.promoMessage
        };


        return (
            <div className="description">
                <Loader/>
                {!this.isMobile() &&
                <React.Fragment>
                    <p className="commonStyle productName">{this.props.productName}</p>
                    <p className="commonStyle productOwner">{this.props.productOwner}</p>
                </React.Fragment>
                }

                {
                    this.isMobile() &&
                    <CallToActionBlock
                        shareId={shareId}
                        likesCommentDataReducer={likesCommentDataReducer}
                        postLikeUnLike={this.props.postLikeUnLike}
                        editProjectUrl={this.props.editProjectUrl}
                        shareUrl={this.props.shareUrl}
                        originalSharedProjectGuid={this.props.originalSharedProjectGuid}
                    />
                }

                <DisplayPricing {...pricingPorps} />
                {/* <p className="commonStyle productDescription">
          {this.props.productDescription}
        </p> */}

                <div className="makeMyOwn">
                    <div className="wrapper">
                        {/* <div className="inline-block">
                            <PrimaryButton
                                onClick={() => {
                                    addToCart(true);
                                }}
                                data-linkname="share-product:add to cart">Add to Cart
                            </PrimaryButton>
                        </div>*/}

                        <div className="inline-block1">
                            <SecondaryButton
                                className="button-fixed-width"
                                data-linkname="share-product:save"
                                onClick={this.showModal}>save
                            </SecondaryButton>
                        </div>
                    </div>

                    {/* <a className="removelinkdefault"
             onClick={this.logOmnitureEvent.bind(
              this,
              "personalize",
              this.props.editProjectUrl,
              "true",
              "true"
            )}
            href="#"
            style={{ display: this.isMobile() ? "none" : "block" }}> Make my own </a> */}
                </div>
                <Modal
                    onClose={this.onCloseModal}
                    show={this.state.show}
                    saveProject={this.saveProject}
                    checkIfMobileDevice={this.isMobile}
                >
                    {this.props.previewSubtitle}
                </Modal>
            </div>
        );
    }
}

export default ProductDescription;
